import { PART_SMART_NUMBER_PREFIX } from "@/features/sub-families/resources/constants.ts";
import type { Part, PartNo } from "@/features/sub-families/types";
import type { Nullable, SmartNumberDescriptorKey } from "@/types";

export const getPartDescriptor = (part: Part): SmartNumberDescriptorKey => {
    return `${PART_SMART_NUMBER_PREFIX}${part.partNo}` as SmartNumberDescriptorKey;
};

export const isPartDescriptorKey = (key: SmartNumberDescriptorKey) => key.startsWith(PART_SMART_NUMBER_PREFIX);

export const getPartNumberFromDescriptor = (key: SmartNumberDescriptorKey): Nullable<PartNo> => {
    if (!isPartDescriptorKey(key)) return null;
    return key.replace(PART_SMART_NUMBER_PREFIX, "") as PartNo;
};
